<template>
	<div class="loadMoreWrapper">
		<div class="lucky">
			<div class="go_back"><span @click="goBack" class="goBackBtn"></span></div>
			<span @click="showlucky(0)" :class="lucky == 0 ? '-active' : ''">智联生活</span>
		</div>
		<mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" class="loadmore">
			<ul class="listBox" v-show="lucky == 0">
				<li class="serviceList" v-for="(item, index) in list" :key="index">
					<router-link :to="'/service/detail/' + item.id">
						<p class="title">{{ item.articleTitle }}</p>
						<span class="time">{{ item.createTime }}</span>
						<div class="bgImg" v-if="item.articleImgName6 != null">
							<img v-lazy="'http://www.zhilianyueju.com/' + item.articleImgName6" :key="'http://www.zhilianyueju.com/' + item.articleImgName6" />
						</div>

						<div v-if="item.articleContent != null" class="con" v-html="item.articleContent"></div>
					</router-link>
				</li>
			</ul>
			<div class="text-center moreData">{{ this.loadText }}</div>
		</mt-loadmore>
	</div>
</template>
<script>
import Api from '../../api/api';
import { Toast, Indicator } from 'mint-ui';

export default {
	name: 'service',
	data() {
		return {
			lucky: 0,
			list: [],
			loadText: null,
			pageNum: 0,
			allLoaded: false,
			img: null
		};
	},
	mounted() {},
	methods: {
		showlucky(index) {
			this.lucky = index;
		},
		goBack() {
			this.$router.back(-1);
		},
		loadBottom() {
			if (!this.allLoaded) {
				this.allLoaded = true;
				setTimeout(() => {
					let pageNum = Number(this.pageNum);
					if (isNaN(pageNum) || pageNum < 0) {
						pageNum = 0;
					}
					pageNum++;
					// console.log('100009')
					this.getList(pageNum);
					this.$refs.loadmore.onBottomLoaded();
				}, 10);
			}
		},

		loadTop() {
			setTimeout(() => {
				this.loadPageList();
				this.$refs.loadmore.onTopLoaded();
			}, 1000);
		},
		loadPageList() {
			let str = 'pageNo=1';
			str += '&pageSize=10';
			Indicator.open({
				spinnerType: 'fading-circle'
			});

			this.loadText = null;

			Api.articleList(
				str,
				msg => {
					Indicator.close();
					if (msg.code == 200) {
						let results = msg.body.results;
						this.list = results;
						this.pageNum = msg.body.pageNo;
						this.isHasMore(msg.body.lastPage);
					}
				},
				() => {
					Indicator.close();
				}
			);
		},
		getList(pageNo) {
			let str = 'pageNo=' + pageNo;
			str += '&pageSize=10';

			Indicator.open({
				spinnerType: 'fading-circle'
			});

			Api.articleList(
				str,
				msg => {
					Indicator.close();
					if (msg.code == 200) {
						let arr = this.list;
						let results = msg.body.results;
						let list = arr.concat(results);
						this.pageNum = msg.body.pageNo;
						this.list = list;
						this.isHasMore(msg.body.lastPage);
					}
				},
				() => {
					Indicator.close();
				}
			);
		},
		isHasMore(lastPage) {
			if (lastPage) {
				this.allLoaded = true;
				this.loadText = '没有更多了...';
			} else {
				this.allLoaded = false;
			}
		}
	}
};
</script>
<style scoped>
@import url('./style/service.css');

.goBackBtn {
	display: inline-block;
	background-image: url('../../assets/images/fanhui.png');
	background-size: 22px;
	background-position: center;
	background-repeat: no-repeat;
	width: 44px;
	height: 44px;
	float: left;
	position: absolute;
	top: 0;
	left: 0;
	margin: 0;
}
.bgImg {
	display: block;
	max-height: 15vh;
	overflow: hidden;
	border-radius: 5px;
	min-height: 100px;
	text-align: center;
	position: relative;
	background-color: #eee;
}
img {
	min-height: 48px;
	min-width: 48px;
	width: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
img[lazy='loading'] {
	height: 48px;
	width: 48px;
}
img[lazy='loaded'] {
	min-height: 48px;
	min-width: 48px;
	background-color: #fff;
}
img[lazy='error'] {
	background: url(../../assets/images/fail.png) no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/service/service.vue